import * as React from "react";
import { PlayerLinks } from "./PlayerLinks";
import { FavoriteGames } from "./FavoriteGames";
import { Watching } from "./Watching";
import { CurrentlyPlaying } from "./CurrentlyPlaying";
import { Accomplishments } from "./Accomplishments";

export class Profile extends React.Component<any, any> {
  public render() {
    const { profile } = this.props;
    return (
      <div className="wrapper">
        <div className="top-section">
          <div className="player-information">
            <div className="player-name-box">
              <h1 className="player-name">{profile.name}</h1>
              <span className="player-location-and-age">
                {profile.location}, {profile.age}
              </span>
            </div>
            <PlayerLinks links={profile.links} />
            <div className="player-description">{profile.description}</div>
          </div>
          <img className="avatar" src={profile.avatar} alt="Player Avatar" />
        </div>
        <div className="section">
          <h2>Favorite games</h2>
          <FavoriteGames
            games={profile.games}
            favoriteGames={profile.favoriteGames}
          />
        </div>
        <div className="section watching-and-playing">
          <Watching
            watching={profile.watching}
            broadcasters={profile.broadcasters}
            broadcastPlatforms={profile.broadcastPlatforms}
          />
          <CurrentlyPlaying games={profile.games} playing={profile.playing} />
        </div>
        <div className="section">
          <h2>Accomplishments</h2>
          <Accomplishments
            games={profile.games}
            accomplishments={profile.accomplishments}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Profile/Profile.tsx